import * as tslib_1 from "tslib";
var TableCalculationsUtils = /** @class */ (function () {
    function TableCalculationsUtils() {
        this.pointsCalculationStrategies = {
            acceptedPercentage: 'calculatePercentageGreterBetterScore',
            refusedPercentage: 'calculatePercentageLowerBetterScore',
            completedPercentage: 'calculatePercentageGreterBetterScore',
            incompletedPercentage: 'calculatePercentageLowerBetterScore',
            averageRating: 'calculateStarScore',
            responseOnTimePercentage: 'calculatePercentageGreterBetterScore',
            solutionOnTimePercentage: 'calculatePercentageGreterBetterScore',
            requestedInterval: 'calculateMeanTimeScoreInSeconds',
            onNegotiationInterval: 'calculateMeanTimeScoreInSeconds',
            pendingInterval: 'calculateMeanTimeScoreInSeconds',
            scheduledInterval: 'calculateMeanTimeScoreInSeconds',
            inProgressInterval: 'calculateMeanTimeScoreInSeconds',
            reportedInterval: 'calculateMeanTimeScoreInSeconds',
            responseInterval: 'calculateMeanTimeScoreInSeconds',
            solutionInterval: 'calculateMeanTimeScoreInSeconds',
            averageResponseTimeInDays: 'calculateMeanTimeScoreInDays',
            averageCloseTimeInDays: 'calculateMeanTimeScoreInDays',
            responseOnTimePercentageByRange: 'calculatePercentageByRange',
            solutionOnTimePercentageByRange: 'calculatePercentageByRange',
        };
        this.discountCalculationStrategies = {
            responseOnTimePercentageByRange: 'calculateDiscountByPercentageByRange',
            solutionOnTimePercentageByRange: 'calculateDiscountByPercentageByRange',
        };
    }
    TableCalculationsUtils.prototype.getTotalPoints = function (criterias) {
        var totalPoints = 0;
        for (var key in criterias) {
            if (criterias.hasOwnProperty(key)) {
                totalPoints += criterias[key].points;
            }
        }
        return totalPoints;
    };
    TableCalculationsUtils.prototype.getTotalDiscount = function (criterias) {
        var totalDiscount = 0;
        for (var key in criterias) {
            if (criterias.hasOwnProperty(key)) {
                totalDiscount += criterias[key].discount || 0;
            }
        }
        return totalDiscount;
    };
    TableCalculationsUtils.prototype.calculatePercentageGreterBetterScore = function (acceptedPercentage, points) {
        return (acceptedPercentage * points) / 100;
    };
    TableCalculationsUtils.prototype.calculatePercentageLowerBetterScore = function (acceptedPercentage, points) {
        return ((100 - acceptedPercentage) * points) / 100;
    };
    TableCalculationsUtils.prototype.calculateMeanTimeScoreInDays = function (days, maxHours, maxScore) {
        var hours = days * 24;
        if (hours <= maxHours) {
            return maxScore;
        }
        return (maxHours / hours) * maxScore;
    };
    TableCalculationsUtils.prototype.calculateMeanTimeScoreInSeconds = function (seconds, maxHours, maxScore) {
        var hours = seconds / 3600;
        if (hours <= maxHours) {
            return maxScore;
        }
        return (maxHours / hours) * maxScore;
    };
    TableCalculationsUtils.prototype.calculatePercentageByRange = function (value, matchingCriteria) {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(matchingCriteria.value.percentRange), _c = _b.next(); !_c.done; _c = _b.next()) {
                var range = _c.value;
                var start = range.start < range.end ? range.start : range.end;
                var end = range.start > range.end ? range.start : range.end;
                if (value >= start && value <= end) {
                    return range.points;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return 0;
    };
    TableCalculationsUtils.prototype.calculateDiscountByPercentageByRange = function (value, matchingCriteria) {
        var e_2, _a;
        try {
            for (var _b = tslib_1.__values(matchingCriteria.value.percentRange), _c = _b.next(); !_c.done; _c = _b.next()) {
                var range = _c.value;
                var start = range.start < range.end ? range.start : range.end;
                var end = range.start > range.end ? range.start : range.end;
                if (value >= start && value <= end) {
                    return range.discount;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return 0;
    };
    TableCalculationsUtils.prototype.calculateStarScore = function (stars, maxScore) {
        var maxStars = 5;
        if (stars >= maxStars) {
            return maxScore;
        }
        return (stars / maxStars) * maxScore;
    };
    TableCalculationsUtils.prototype.calculatePointsForCriteria = function (key, value, matchingCriteria) {
        var strategy = this.pointsCalculationStrategies[key];
        var isMeanTimeScore = ['calculateMeanTimeScoreInSeconds', 'calculateMeanTimeScoreInDays'];
        var isRangePercent = ['calculatePercentageByRange'];
        if (!strategy) {
            return 0;
        }
        if (isRangePercent.includes(strategy)) {
            return this[strategy](value, matchingCriteria);
        }
        if (isMeanTimeScore.includes(strategy)) {
            return this[strategy](value, matchingCriteria.value.resultThreshold, matchingCriteria.value.points);
        }
        return this[strategy](value, matchingCriteria.value.points);
    };
    TableCalculationsUtils.prototype.calculateDiscountForCriteria = function (key, value, matchingCriteria) {
        var strategy = this.discountCalculationStrategies[key];
        var isRangePercent = ['calculateDiscountByPercentageByRange'];
        if (!strategy) {
            return 0;
        }
        if (isRangePercent.includes(strategy)) {
            return this[strategy](value, matchingCriteria);
        }
        return 0;
    };
    return TableCalculationsUtils;
}());
export { TableCalculationsUtils };
